'use client';
import React, {useEffect, useRef, useState} from 'react'
import { useScroll, motion, progress, useTransform, MotionValue } from 'motion/react'
import { AboutCopy } from '@/app/copywritting';

const AboutSection = () => {

  const [emblemSize, setEmblemSize] = useState(80);

  useEffect(() => {
    if (window.matchMedia(`(max-width: 768px)`).matches){
      setEmblemSize(40)
    } else {
      setEmblemSize(80)
    }
  },[]);

  

  const element = useRef(null);
  const {scrollYProgress} = useScroll({
    target: element,
    offset: ['start 0.9', 'start 0.35']
  })  

  const words = AboutCopy.mainText.split(" ");

  return (
    <section className="h-120 md:h-screen flex flex-col justify-center items-center">
      <img alt='Shadows Collective Logo' src={'/shdws-emblem-vulcan-lg.png'} width={emblemSize} height={emblemSize}></img>
      <img alt='Shadows Collective Leters' className='pb-15' src={'/shdws_lettering_vulcan.svg'} width={250} ></img>
      <p ref={element} className="flex flex-wrap w-full  md:w-[75%] text-2xl md:text-5xl text-center font-bold tracking-tighter leading-about-mobile md:leading-none justify-center"> 
          {
            words.map((word:any, index)=>{
              const start = index / words.length;
              const end = start + (1 / words.length);
              return <Word key={index} range={[start, end]} progress={scrollYProgress}>{word}</Word>
            })
          }
        </p>
    </section>
  )
}

export default AboutSection

interface WordProps {
  children: React.ReactNode;
  range:[number, number];
  progress: MotionValue<number>;
}

const Word = ({children, range, progress}: WordProps) => {
  const opacity = useTransform(progress, range, [0, 1]);
  return (
    <span className='relative'>
      <span className='absolute opacity-[0.1] mr-[6px]  leading-none'>
        {children}
      </span>
      <motion.span className='mr-[6px] mt-[6px] leading-none' style={{opacity}}>{children}</motion.span>
    </span>
    
  )
}